import { render } from "./Previsione.vue?vue&type=template&id=2531fc6f&ts=true"
import script from "./Previsione.vue?vue&type=script&lang=ts"
export * from "./Previsione.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__